import { borderRadius } from 'react-select/src/theme';
export const bullets = {
  color: '#C4C4C4',
  padding: '0px 10px',
  // marginTop: '5px',
};
export const phaseName = {
  color: '#333',
  fontSize: '20px',
  textTransform: 'capitalize',
  marginLeft: '5px',
  maxWidth: '832px',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden' as 'hidden',
  display: 'inline-block',
};
export const dateStyle = {
  color: '#999',
  fontSize: '16px',
};
export const editCTC = {
  cursor: 'pointer',
  marginLeft: '20px',
};
export const disableEditCta = {
  cursor: 'default',
  marginLeft: '12px',
  opacity: 0.5,
};
export const deleteIcon = {
  cursor: 'pointer',
  marginLeft: '20px',
};

export const chipStyle ={
  backgroundColor: '#9361dd',
  margin: "0 0 0 10px",
  height: 20,
  minWidth: 52,
  fontSize: 12,
  color: '#fff',
  border: 'none',
};